/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-ZLBdPP': alignSelf,'--mt-2-ZLBdPP': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZLBdPP': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZLBdPP': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZLBdPP': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZLBdPP': opacity,'--w-10-ZLBdPP': typeof width === 'number' ? `${width}px` : width,'--h-11-ZLBdPP': typeof height === 'number' ? `${height}px` : height,'--f-12-ZLBdPP': fill,'--a-7-ZLBdPP': isAnimated ? animation : "none",'--sd-8-ZLBdPP': isAnimated ? strokeDashoffset : 0,'--sd-9-ZLBdPP': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3 0c.473 0 .857.384.857.857v.857h4.286V.857a.857.857 0 111.714 0v.857h.857C11.424 1.714 12 2.29 12 3v7.714c0 .71-.576 1.286-1.286 1.286H1.286C.576 12 0 11.424 0 10.714V3c0-.71.576-1.286 1.286-1.286h.857V.857C2.143.384 2.527 0 3 0zm1.605 6c0-.297.24-.538.538-.538H8.57a.538.538 0 110 1.076H5.143A.538.538 0 014.605 6zm.538 2.034a.538.538 0 000 1.075H6a.538.538 0 100-1.075h-.857zM2.463 6c0-.297.24-.538.537-.538h.429a.538.538 0 010 1.076H3A.538.538 0 012.462 6zM3 8.034a.538.538 0 000 1.075h.429a.538.538 0 100-1.075H3z"
 style={{'--f-12-ZLBdPP': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}